import { call, put } from 'redux-saga/effects';
import { attendanceConstants } from '../actions/constants/attendanceConstants';
import { attendanceService } from '../services/attendanceService';
import { eventActions } from '../actions/eventActions';
import { commonConstants } from '../actions/constants/commonConstants';

function* markAttendance(action: any): any {
  try {
    const response = yield call(attendanceService.markAttendanceByUrl, action.payload);
    if (response && response.success) {
      yield put({ type: attendanceConstants.markAttendanceSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showSuccessMessage, payload: response.message });
      yield put(eventActions.listEventsRequest({ page: 1, limit: 10 }));
    } else {
      yield put({ type: attendanceConstants.markAttendanceFailure, payload: response?.errorMessage || response });
      yield put({ type: commonConstants.showErrorMessage, payload: response?.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: attendanceConstants.markAttendanceFailure, payload: error });
    yield put({ type: commonConstants.showErrorMessage, payload: error?.errorMessage });
  }
}

function* getEventAttendance(action: any): any {
  try {
    const response = yield call(attendanceService.getEventAttendance, action.payload?.eventId || action.payload);
    if (response && response.success) {
      yield put({ type: attendanceConstants.getEventAttendanceSuccess, payload: response.resultObject });
    } else {
      yield put({ type: attendanceConstants.getEventAttendanceFailure, payload: response?.errorMessage || response });
      yield put({ type: commonConstants.showErrorMessage, payload: response?.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: attendanceConstants.getEventAttendanceFailure, payload: error });
    yield put({ type: commonConstants.showErrorMessage, payload: error?.errorMessage });
  }
}

export { markAttendance, getEventAttendance };
